import React, { useState } from "react";
import pembicaraData from "../dataJSON/pembicaraData.json";
import { PembicaraPosts } from "./PembicaraDetails/PembicaraPosts";

const DetailsSpeaker = () => {
  const [posts] = useState(pembicaraData);

  // useEffect(() => {
  //   //Arrow Function untuk ngambil data dari API
  //   const fetchPosts = async () => {
  //     setLoading(true);
  //     const res = await axios.get("http://localhost:3000/posts");
  //     setPosts(res.data);
  //     setLoading(false);
  //   };

  //   fetchPosts();
  // }, []);

  console.log(posts);

  return (
    <section className="pembicaraDetails-container">
      <PembicaraPosts />
    </section>
  );
};

export default DetailsSpeaker;
